<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Amministratori'
    }]"
  />
  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
      <SearchSelect
        v-model="role"
        name="admin-role"
        :options="{ 'global_manager': 'Global Manager', 'auction_manager': 'Auction Manager', 'base_manager': 'Base Manager' }"
      />
    </div>
    <div class="self-end">
      <ActionButton @click="router.push('/amministratori/crea')">
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Amministratore
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="email"
        >
          Email
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="role"
        >
          Ruolo
        </SortableColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="admin in data"
        :key="'admin-table-' + admin.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ admin.email }}
        </td>
        <td class="p-2">
          {{ admin.role }}
        </td>
        <td class="p-2 text-right">
          <a
            href="#"
            title="Invia Reset Password"
            @click.prevent="resetPassword(admin)"
          >
            <EnvelopeIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            href="#"
            title="Elimina Amministratore"
            @click.prevent="destroy(admin)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  EnvelopeIcon,
  PlusCircleIcon,
  TrashIcon
} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRouter } from 'vue-router';

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SearchSelect from "@/components/list/SearchSelect.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js';

const router = useRouter()

const search = ref('')
const role = ref()

const sortStatus = ref(["email", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/admin-user/list",
  sortStatus,
  search,
  searchProperties: ['email'],
  extraFilter: (item) => {
    return role.value ? item.role == role.value : true;
  }
})

watch(role, () => {
  doFilter()
})

const destroy = (admin) => {
  action('delete', 'admin-user/' + admin.uuid, 'Amministratore eliminato con successo')
}

const resetPassword = (admin) => {
  action('get', 'admin-user/reset-password/' + admin.uuid, 'E-Mail inviata con successo')
}
</script>
